// @ts-strict-ignore
import React from 'react';
import { AppComponentProps } from '../typescriptHelpers';
import Text from 'antd/lib/typography/Text';
import { titleStyle, pageHeaderStyle, antGrey, runwayColors } from './styles/globalStyles';
import { ArrowLeftOutlined } from '@ant-design/icons';

import Layout from 'antd/lib/layout';
import { useHistory } from 'react-router-dom';

interface PageLayoutProps extends AppComponentProps {
    component: React.ComponentType<AppComponentProps>;
    title: string;
    description: string;
    banners?: React.ReactNode;
    backNavigationRoute?: string;
}

const PageLayout: React.FC<PageLayoutProps> = (props: PageLayoutProps) => {
    const { component: Component, title, description, banners, backNavigationRoute, ...rest } = props;

    const history = useHistory();

    return (
        <Layout
            style={{
                backgroundColor: runwayColors.white,
                position: 'relative',
            }}
        >
            {banners}
            <div style={{ padding: 24, paddingBottom: 95, overflow: 'auto' }}>
                <div style={{ ...pageHeaderStyle, paddingRight: 0, display: 'flex', alignItems: 'center' }}>
                    {backNavigationRoute && (
                        <ArrowLeftOutlined
                            style={{ color: antGrey.grey7, marginRight: 12, cursor: 'pointer', fontSize: 16 }}
                            onClick={() => history.push(backNavigationRoute)}
                        />
                    )}
                    <Text style={titleStyle} type="secondary">
                        {title}
                    </Text>
                </div>
                {description && <Text>{description}</Text>}
                <div style={{ paddingBlockStart: description ? '48px' : '20px' }}>
                    <Component {...rest} />
                </div>
            </div>
        </Layout>
    );
};

export default PageLayout;
